import i18next from 'i18next';
import { Locations } from '../Constants/Common';

const nonUkLocations = Object.values(Locations).filter(
    (location) => location !== Locations.Uk
);

export const nonUsLocations = Object.values(Locations).filter(
    (location) => location !== Locations.Us
);

export function isAllowedInLocation(
    allowedLocations: string[],
    currentLocation: string
) {
    return (
        !allowedLocations ||
        !location ||
        allowedLocations.some((c) => {
            if (c === Locations.Uk) {
                // if not in nonUkLocations then it is UK
                // we have to do this because 'en' is not set as a default language for UK
                return nonUkLocations.every((l) => l !== currentLocation);
            }
            return c === currentLocation;
        })
    );
}

const getSafeLanguage = (lang) => {
    return i18next.store.data[lang]
        ? lang
        : localStorage.getItem('i18nextLng') ||
              i18next.options.fallbackLng?.[0] ||
              i18next.options.fallbackLng;
};

export const setLanguageSafe = (lang) => {
    const safeLanguage = getSafeLanguage(lang);
    if (i18next.store.data[safeLanguage]) {
        i18next.changeLanguage(safeLanguage);
    }
};
